import { LineItem } from './lineitem.model';
import { Policy } from './policy.model';
import { Provider } from './provider.model';

export class Response {
  governmentFeesAndTaxes: LineItem[];
  titleProvider: Provider;
  lendersPolicy: Policy;
  ownersPolicy: Policy;
  endorsements: LineItem[];
  settlementFees: LineItem[];
  inspectionFees: LineItem[];
  propertyTaxes: LineItem[];
}
